import React from 'react';
import { Typography } from '@one-thd/sui-atomic-components';
var QRCode = function (_a) {
    var sorisId = _a.sorisId, imageSrc = _a.imageSrc;
    return (React.createElement("div", { className: "qr-code-size" },
        React.createElement("img", { src: imageSrc, height: 233, width: 233, alt: "QR Code" }),
        React.createElement("div", { className: "sui-flex sui-justify-center sui-mt-4" },
            React.createElement(Typography, { variant: "body-xs" },
                "Return ID: ",
                sorisId))));
};
export default QRCode;
